import { Button, SimpleGrid, Stack, Text } from "@mantine/core";
import { useTranslation } from "react-i18next";
import { COLOR_THEME_OPTIONS } from "@/app/theme";
import { SettingPanel } from "@/features/account/ui/setting-panel";
import { useTillAppearance } from "@/features/content/use-till-appearance";

export function TillAppearancePanel() {
	const { t } = useTranslation();
	const { scheme, theme, isPending, applyScheme, applyTheme } =
		useTillAppearance();

	return (
		<SettingPanel
			title={t("staff.cardSchemeTitle")}
			hint={t("staff.cardSchemeHint")}
			prominent
		>
			<Stack gap="md">
				<div>
					<Text size="sm" fw={500} mb="xs">
						{t("staff.cardThemeLabel")}
					</Text>
					<SimpleGrid cols={2} spacing="xs">
						{COLOR_THEME_OPTIONS.map(({ value, labelKey }) => (
							<Button
								key={value}
								size="md"
								variant={theme === value ? "filled" : "default"}
								loading={isPending}
								onClick={() => applyTheme(value)}
							>
								{t(labelKey)}
							</Button>
						))}
					</SimpleGrid>
				</div>
				<div>
					<Text size="sm" fw={500} mb="xs">
						{t("staff.cardSchemeLabel")}
					</Text>
					<SimpleGrid cols={2} spacing="xs">
						<Button
							size="md"
							variant={scheme === "light" ? "filled" : "default"}
							loading={isPending}
							onClick={() => applyScheme("light")}
						>
							{t("staff.schemeLight")}
						</Button>
						<Button
							size="md"
							variant={scheme === "dark" ? "filled" : "default"}
							loading={isPending}
							onClick={() => applyScheme("dark")}
						>
							{t("staff.schemeDark")}
						</Button>
					</SimpleGrid>
				</div>
			</Stack>
		</SettingPanel>
	);
}
